<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="ni ni-tv-2"
        main="Relatórios"
        sub="Avaliações"
      ></page-title>
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label class="form-control-label"> Ano ppr </label>
            <multiselect
              v-model="filter.participation_ppr"
              placeholder="Selecionar Ano Ppr"
              :options="participations"
              :loading="!participations.length"
              label="descricao"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
            />
          </div>

          <div class="col-4">
            <label class="form-control-label"> Grupo </label>
            <multiselect
              placeholder="Selecione o Grupo"
              v-model="filter.role"
              :options="roles"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="name"
              track-by="id"
            />
          </div>

          <div v-if="filter.role.name == 'VENDEDOR'" class="col-4">
            <label class="form-control-label"> Gerente Comercial </label>
            <multiselect
              placeholder="Selecione o Gerente Comercial"
              v-model="filter.manager"
              :options="managers"
              label="name"
              track-by="id"
            />
          </div>

          <div v-if="filter.role.name == 'VENDEDOR'" class="col-4">
            <label class="form-control-label"> Tipo de Vendedor </label>
            <multiselect
              placeholder="Tipo de vendedor"
              v-model="filter.type"
              :options="types"
              label="salesman_type"
              track-by="code"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
            />
          </div>
          <div v-if="filter.role.name == 'VENDEDOR'" class="col-4">
            <label class="form-control-label"> Segmento </label>
            <multiselect
              placeholder="Selecione o segmento"
              v-model="filter.channel"
              :options="channels"
              label="description"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
            />
          </div>
          <div class="col-4">
            <label class="form-control-label"> {{ this.filter.role.name == "VENDEDOR" ? "Vendedor" : "Usuário" }} </label>
            <multiselect
              placeholder="Selecione o Usuário"
              v-model="filter.user"
              :options="users"
              :loading="loadingUsers"
              label="name"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              @input="updateTypeAndChannel()"
              @search-change="getUsers"

            />
          </div>

        </div>
        <div slot="footer" class="row justify-content-end mr-1">
          <base-button
            type="secondary"
            class="mr-2"
            @click="clearFilters">
            Limpar Filtros
          </base-button>
          <base-button
            v-loading="isLoadingPDF"
            type="secondary"
            class="mr-2"
            @click="generatePDF"
          >
            Gerar PDF</base-button
          >
          <base-button
            v-loading="isLoadingExcel"
            type="secondary"
            class="mr-2"
            @click="exportToExcel"
          >
            Gerar Excel</base-button
          >
          <base-button
            type="primary"
            @click="generateReport"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card v-show="reports == true" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Avaliação PPR - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.user && Object.keys(filter.user).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          {{ filter.role.name }} - {{ filter.user.name }}
        </h6>
      </div>
      <br />
      <h4 class="text-uppercase text-muted ls-1 mb-1">
        Avaliação
      </h4>
      <br />
      <el-table
        v-loading="isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="resultGoals"
        stripe="stripe"
        border
        style="width: 100%;"
      >
        <el-table-column label="Item" prop="item" max-width="30px" sortable>
          <el-table-column min-width="125px" prop="item" />
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="weight" />
        </el-table-column>

        <el-table-column label="%" prop="percentage" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="percentage" v-slot="{ row }">
            {{ formatValue(row.percentage) }}%
          </el-table-column>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="points" v-slot="{ row }">
            {{ formatValue(row.points) }}
          </el-table-column>
        </el-table-column>
      </el-table>
      <br />
      <h4 class="text-uppercase text-muted ls-1 mb-1">
        Avaliação Com
      </h4>
      <br />
      <el-table
        v-loading="isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="resultGoalsWith"
        stripe="stripe"
        border
        style="width: 100%;"
      >
        <el-table-column label="Item" prop="item" max-width="30px" sortable>
          <el-table-column min-width="125px" prop="item" />
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="weight" />
        </el-table-column>

        <el-table-column label="%" prop="percentage" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="percentage" v-slot="{ row }">
            {{ formatValue(row.percentage) }}%
          </el-table-column>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="points" v-slot="{ row }">
            {{ formatValue(row.points) }}
          </el-table-column>
        </el-table-column>
      </el-table>
      <br />
      <h4 class="text-uppercase text-muted ls-1 mb-1">
        Avaliação Agd's
      </h4>
      <br />
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="resultGoalsAgd"
        stripe="stripe"
        border
        style="width: 100%;"
      >
        <el-table-column label="Item" prop="item" max-width="30px" sortable>
          <el-table-column min-width="125px" prop="item" />
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="weight" />
        </el-table-column>

        <el-table-column label="%" prop="percentage" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="percentage" v-slot="{ row }">
            {{ formatValue(row.percentage) }}%
          </el-table-column>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <el-table-column min-width="125px" prop="points" v-slot="{ row }">
            {{ formatValue(row.points) }}
          </el-table-column>
        </el-table-column>
      </el-table>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { Table, TableColumn } from "element-ui";
import Card from "../../components/Cards/Card.vue";

export default {
  components: {
    PageTitle,
    Multiselect,
    Card,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      filter: {
        participation_ppr: {},
        role: {},
        user: {},
      },
      anosafra_user: {},
      anosafra_users: [],
      paginated_data: {},
      anosafras: [],
      roles: [],
      users: [],
      channels: [],
      channel: {},
      managers: [],
      manager: {},
      salesman: {},
      salesmans: [],
      type: {},
      types: [],
      quantitativeGoals: [],
      personalGoals: [],
      qualitativeGoals: [],
      resultGoals: [],
      resultGoalsWith: [],
      resultGoalsAgd: [],
      reports: false,
      participation: [],
      participations: [],
      avaliations: [],
      isLoading: false,
      loadingUsers: false,
      isLoadingPDF: false,
      isLoadingExcel: false,
      isLoadingReport: false,
      lastEdition: new Date(),
    };
  },
  computed: {
    excelData() {
      return [this.resultGoals];
    },
  },

  methods: {
    formatValue(value) {
      return (parseFloat(value) || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    updateTypeAndChannel(){
      if (!(this.channels && this.channels.length)) this.channels = []
      if (!(this.types    && this.types.length))    this.getTypes()

      if(this.filter.user.channels.length){
         const channels = this.filter.user.channels.map(channel  => ({
          id: channel.id,
          description: channel.description
        }))

        this.channels.push(...channels)
        this.setUserType()
      }
    },
    setUserType(){
      if (!(this.types && this.types.length)) this.getTypes()

      const salesmanTypeCodes = {
        campo: {code: "C", salesman_type: "CAMPO"},
        balcao: {code: "B", salesman_type: "BALCÃO"},
        redistribuicao: {code: "R", salesman_type: "REDISTRIBUIÇÃO"}
      }

      if(this.filter.user.salesman_type && this.filter.user.salesman_type != undefined) {
        this.types.push(salesmanTypeCodes[this.filter.user.salesman_type])
      }
    },
    generatePDF() {
      this.isLoadingPDF = true;
      window.print();
      this.isLoadingPDF = false;
    },
    exportToExcel() {
      this.isLoadingExcel = true;
      this.isLoadingExcel = false;

      return this.$exportToExcel();
    },
    generateReport() {
      this.isLoading = true;
      this.reports = true;
      this.getAvaliationResume();
      this.getAvaliationWith();
      this.getAvaliationAgd();
      this.isLoading = false;
    },
    getAvaliationResume() {
      let dataAvaliation = {
        q: {
          participation_ppr_id: this.filter.participation_ppr.id,
          role_id: this.filter.role.id,
          user_id: this.filter.user.id
        },
      };
      this.$http.secured
        .get(`/api/v1/avaliation_resumes`, { params: dataAvaliation })
        .then((response) => {
          this.avaliations = response.data;
          console.log("Avaliação", this.avaliations);
          this.lastEdition = new Date();
          let pointsQuantitative = 0;
          let totalQuantitative = 0;
          let pointsPersonalGoals = 0;
          let totalPersonalGoals = 0;
          let pointsQualitativeGoal = 0;
          let totalQualitativeGoal = 0;

          if (response.data.length == 0) {
            this.editMode = true;

            //starting values
            this.descriptionQuantitatives.map((description) => {
              this.quantitativeGoals.push({
                id: 0,
                kind: "METAS QUANTITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionsPessoal.map((description) => {
              this.personalGoals.push({
                id: 0,
                kind: "METAS PESSOAIS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionQualitatives.map((description) => {
              this.qualitativeGoals.push({
                id: 0,
                kind: "METAS QUALITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
          } else {
            this.quantitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUANTITATIVAS"
            );
            this.personalGoals = response.data.filter(
              (data) => data.kind == "METAS PESSOAIS"
            );
            this.qualitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUALITATIVAS"
            );

            this.quantitativeGoals.map((quantitativeGoal) => {
              pointsQuantitative += quantitativeGoal.weight * 10;
              totalQuantitative +=
                quantitativeGoal.grade * quantitativeGoal.weight;

              let points = quantitativeGoal.weight * 10;
              let total = quantitativeGoal.grade * quantitativeGoal.weight;
              quantitativeGoal.points = points;
              quantitativeGoal.total = total;
            });
            this.personalGoals.map((personalGoal) => {
              pointsPersonalGoals += personalGoal.weight * 10;
              totalPersonalGoals += personalGoal.grade * personalGoal.weight;

              let points = personalGoal.weight * 10;
              let total = personalGoal.grade * personalGoal.weight;
              personalGoal.points = points;
              personalGoal.total = total;
            });
            this.qualitativeGoals.map((qualitativeGoal) => {
              pointsQualitativeGoal += qualitativeGoal.weight * 10;
              totalQualitativeGoal +=
                qualitativeGoal.grade * qualitativeGoal.weight;

              let points = qualitativeGoal.weight * 10;
              let total = qualitativeGoal.grade * qualitativeGoal.weight;
              qualitativeGoal.points = points;
              qualitativeGoal.total = total;
            });

            let percentageQuantitative = (
              totalQuantitative / pointsQuantitative
            ).toFixed(2);
            let percentagePersonalGoals = (
              totalPersonalGoals / pointsPersonalGoals
            ).toFixed(2);
            let percentageQualitativeGoals = (
              totalQualitativeGoal / pointsQualitativeGoal
            ).toFixed(2);

            let acumulatedPointsQuantitative = (
              0.7 *
              percentageQuantitative *
              1000
            ).toFixed(2);
            let acumulatedPointsPersonalGoals = (
              0.1 *
              percentagePersonalGoals *
              1000
            ).toFixed(2);
            let acumulatedPointsQualitative = (
              0.2 *
              percentageQualitativeGoals *
              1000
            ).toFixed(2);

            // percentages treatment
            percentageQuantitative = isNaN(percentageQuantitative)
              ? 0
              : percentageQuantitative;
            percentagePersonalGoals = isNaN(percentagePersonalGoals)
              ? 0
              : percentagePersonalGoals;
            percentageQualitativeGoals = isNaN(percentageQualitativeGoals)
              ? 0
              : percentageQualitativeGoals;
            // points treatment
            acumulatedPointsQuantitative = isNaN(acumulatedPointsQuantitative)
              ? 0
              : acumulatedPointsQuantitative;
            acumulatedPointsPersonalGoals = isNaN(acumulatedPointsPersonalGoals)
              ? 0
              : acumulatedPointsPersonalGoals;
            acumulatedPointsQualitative = isNaN(acumulatedPointsQualitative)
              ? 0
              : acumulatedPointsQualitative;

            let totalPercentage =
              (Number(acumulatedPointsQuantitative) +
                Number(acumulatedPointsPersonalGoals) +
                Number(acumulatedPointsQualitative)) /
              1000;
            let totalPoints =
              Number(acumulatedPointsQuantitative) +
              Number(acumulatedPointsPersonalGoals) +
              Number(acumulatedPointsQualitative);

            if (this.resultGoals.length == 0) {
              this.resultGoals.push({
                item: "Métas Quanti e Quali",
                weight: "70%",
                percentage: percentageQuantitative,
                points: acumulatedPointsQuantitative,
              });
              this.resultGoals.push({
                item: "Apresentação Pessoal",
                weight: "10%",
                percentage: percentagePersonalGoals,
                points: acumulatedPointsPersonalGoals,
              });
              this.resultGoals.push({
                item: "Relacionamento crédito Cobrança",
                weight: "20%",
                percentage: percentageQualitativeGoals,
                points: acumulatedPointsQualitative,
              });
              this.resultGoals.push({
                item: "Total",
                weight: "100%",
                percentage: totalPercentage,
                points: totalPoints,
              });
            } else {
              //update results
              this.resultGoals.map((result) => {
                if (result.item == "Métas Quanti e Quali") {
                  result.percentage = percentageQuantitative;
                  result.points = acumulatedPointsQuantitative;
                } else if (result.item == "Apresentação Pessoal") {
                  result.percentage = percentagePersonalGoals;
                  result.points = acumulatedPointsPersonalGoals;
                } else if (result.item == "Relacionamento crédito Cobrança") {
                  result.percentage = acumulatedPointsQualitative;
                  result.points = percentageQualitativeGoals;
                } else if (result.item == "Total") {
                  result.percentage = totalPercentage;
                  result.points = totalPoints;
                }
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => console.log(error));
    },
    getAvaliationWith() {
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.filter.participation_ppr.id,
          role_id: this.filter.role.id,
          user_id: this.filter.user.id
        },
      };
      this.$http.secured
        .get(`/api/v1/avaliation_withs`, { params: dataAvaliation })
        .then((response) => {
          this.data = response.data;

          let pointsQuantitative = 0;
          let totalQuantitative = 0;
          let pointsPersonalGoals = 0;
          let totalPersonalGoals = 0;
          let pointsQualitativeGoal = 0;
          let totalQualitativeGoal = 0;

          if (response.data.length == 0) {
            this.editMode = true;
            //starting values
            this.descriptionQuantitatives.map((description) => {
              this.quantitativeGoals.push({
                id: 0,
                kind: "METAS QUANTITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionsPessoal.map((description) => {
              this.personalGoals.push({
                id: 0,
                kind: "METAS PESSOAIS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionQualitatives.map((description) => {
              this.qualitativeGoals.push({
                id: 0,
                kind: "METAS QUALITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
          } else {
            this.quantitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUANTITATIVAS"
            );
            this.personalGoals = response.data.filter(
              (data) => data.kind == "METAS PESSOAIS"
            );
            this.qualitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUALITATIVAS"
            );

            this.quantitativeGoals.map((quantitativeGoal) => {
              pointsQuantitative += quantitativeGoal.weight * 10;
              totalQuantitative +=
                quantitativeGoal.grade * quantitativeGoal.weight;

              let points = quantitativeGoal.weight * 10;
              let total = quantitativeGoal.grade * quantitativeGoal.weight;
              quantitativeGoal.points = points;
              quantitativeGoal.total = total;
            });
            this.personalGoals.map((personalGoal) => {
              pointsPersonalGoals += personalGoal.weight * 10;
              totalPersonalGoals += personalGoal.grade * personalGoal.weight;

              let points = personalGoal.weight * 10;
              let total = personalGoal.grade * personalGoal.weight;
              personalGoal.points = points;
              personalGoal.total = total;
            });
            this.qualitativeGoals.map((qualitativeGoal) => {
              pointsQualitativeGoal += qualitativeGoal.weight * 10;
              totalQualitativeGoal +=
                qualitativeGoal.grade * qualitativeGoal.weight;

              let points = qualitativeGoal.weight * 10;
              let total = qualitativeGoal.grade * qualitativeGoal.weight;
              qualitativeGoal.points = points;
              qualitativeGoal.total = total;
            });

            let percentageQuantitative = (
              totalQuantitative / pointsQuantitative
            ).toFixed(2);
            let percentagePersonalGoals = (
              totalPersonalGoals / pointsPersonalGoals
            ).toFixed(2);
            let percentageQualitativeGoals = (
              totalQualitativeGoal / pointsQualitativeGoal
            ).toFixed(2);

            let acumulatedPointsQuantitative = (
              0.7 *
              percentageQuantitative *
              1000
            ).toFixed(2);
            let acumulatedPointsPersonalGoals = (
              0.1 *
              percentagePersonalGoals *
              1000
            ).toFixed(2);
            let acumulatedPointsQualitative = (
              0.2 *
              percentageQualitativeGoals *
              1000
            ).toFixed(2);

            // percentages treatment
            percentageQuantitative = isNaN(percentageQuantitative)
              ? 0
              : percentageQuantitative;
            percentagePersonalGoals = isNaN(percentagePersonalGoals)
              ? 0
              : percentagePersonalGoals;
            percentageQualitativeGoals = isNaN(percentageQualitativeGoals)
              ? 0
              : percentageQualitativeGoals;
            // points treatment
            acumulatedPointsQuantitative = isNaN(acumulatedPointsQuantitative)
              ? 0
              : acumulatedPointsQuantitative;
            acumulatedPointsPersonalGoals = isNaN(acumulatedPointsPersonalGoals)
              ? 0
              : acumulatedPointsPersonalGoals;
            acumulatedPointsQualitative = isNaN(acumulatedPointsQualitative)
              ? 0
              : acumulatedPointsQualitative;

            let totalPercentage =
              (Number(acumulatedPointsQuantitative) +
                Number(acumulatedPointsPersonalGoals) +
                Number(acumulatedPointsQualitative)) /
              1000;
            let totalPoints =
              Number(acumulatedPointsQuantitative) +
              Number(acumulatedPointsPersonalGoals) +
              Number(acumulatedPointsQualitative);

            if (this.resultGoalsWith.length == 0) {
              this.resultGoalsWith.push({
                item: "Métas Quanti e Quali",
                weight: "70%",
                percentage: percentageQuantitative,
                points: acumulatedPointsQuantitative,
              });
              this.resultGoalsWith.push({
                item: "Apresentação Pessoal",
                weight: "10%",
                percentage: percentagePersonalGoals,
                points: acumulatedPointsPersonalGoals,
              });
              this.resultGoalsWith.push({
                item: "Relacionamento crédito Cobrança",
                weight: "20%",
                percentage: percentageQualitativeGoals,
                points: acumulatedPointsQualitative,
              });
              this.resultGoalsWith.push({
                item: "Total",
                weight: "100%",
                percentage: totalPercentage,
                points: totalPoints,
              });
            } else {
              //update results
              this.resultGoalsWith.map((result) => {
                if (result.item == "Métas Quanti e Quali") {
                  result.percentage = percentageQuantitative;
                  result.points = acumulatedPointsQuantitative;
                } else if (result.item == "Apresentação Pessoal") {
                  result.percentage = percentagePersonalGoals;
                  result.points = acumulatedPointsPersonalGoals;
                } else if (result.item == "Relacionamento crédito Cobrança") {
                  result.percentage = acumulatedPointsQualitative;
                  result.points = percentageQualitativeGoals;
                } else if (result.item == "Total") {
                  result.percentage = totalPercentage;
                  result.points = totalPoints;
                }
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => console.log(error));
    },
    getAvaliationAgd() {
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.filter.participation_ppr.id,
          role_id: this.filter.role.id,
          user_id: this.filter.user.id
        },
      };
      this.$http.secured
        .get(`/api/v1/avaliation_agds`, { params: dataAvaliation })
        .then((response) => {
          this.data = response.data;

          let pointsQuantitative = 0;
          let totalQuantitative = 0;
          let pointsPersonalGoals = 0;
          let totalPersonalGoals = 0;
          let pointsQualitativeGoal = 0;
          let totalQualitativeGoal = 0;

          if (response.data.length == 0) {
            this.editMode = true;

            //starting values
            this.descriptionQuantitatives.map((description) => {
              this.quantitativeGoals.push({
                id: 0,
                kind: "METAS QUANTITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionsPessoal.map((description) => {
              this.personalGoals.push({
                id: 0,
                kind: "METAS PESSOAIS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0 * 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
            this.descriptionQualitatives.map((description) => {
              this.qualitativeGoals.push({
                id: 0,
                kind: "METAS QUALITATIVAS",
                description: description,
                weight: 0,
                grade: 0,
                points: 0 * 10,
                total: 0,
                role_id: this.filterRole.id,
                participation_ppr_id: this.anoParticipation.id,
              });
            });
          } else {
            this.quantitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUANTITATIVAS"
            );
            this.personalGoals = response.data.filter(
              (data) => data.kind == "METAS PESSOAIS"
            );
            this.qualitativeGoals = response.data.filter(
              (data) => data.kind == "METAS QUALITATIVAS"
            );

            this.quantitativeGoals.map((quantitativeGoal) => {
              pointsQuantitative += quantitativeGoal.weight * 10;
              totalQuantitative +=
                quantitativeGoal.grade * quantitativeGoal.weight;

              let points = quantitativeGoal.weight * 10;
              let total = quantitativeGoal.grade * quantitativeGoal.weight;
              quantitativeGoal.points = points;
              quantitativeGoal.total = total;
            });
            this.personalGoals.map((personalGoal) => {
              pointsPersonalGoals += personalGoal.weight * 10;
              totalPersonalGoals += personalGoal.grade * personalGoal.weight;

              let points = personalGoal.weight * 10;
              let total = personalGoal.grade * personalGoal.weight;
              personalGoal.points = points;
              personalGoal.total = total;
            });
            this.qualitativeGoals.map((qualitativeGoal) => {
              pointsQualitativeGoal += qualitativeGoal.weight * 10;
              totalQualitativeGoal +=
                qualitativeGoal.grade * qualitativeGoal.weight;

              let points = qualitativeGoal.weight * 10;
              let total = qualitativeGoal.grade * qualitativeGoal.weight;
              qualitativeGoal.points = points;
              qualitativeGoal.total = total;
            });

            let percentageQuantitative = (
              totalQuantitative / pointsQuantitative
            ).toFixed(2);
            let percentagePersonalGoals = (
              totalPersonalGoals / pointsPersonalGoals
            ).toFixed(2);
            let percentageQualitativeGoals = (
              totalQualitativeGoal / pointsQualitativeGoal
            ).toFixed(2);

            let acumulatedPointsQuantitative = (
              0.7 *
              percentageQuantitative *
              1000
            ).toFixed(2);
            let acumulatedPointsPersonalGoals = (
              0.1 *
              percentagePersonalGoals *
              1000
            ).toFixed(2);
            let acumulatedPointsQualitative = (
              0.2 *
              percentageQualitativeGoals *
              1000
            ).toFixed(2);

            // percentages treatment
            percentageQuantitative = isNaN(percentageQuantitative)
              ? 0
              : percentageQuantitative;
            percentagePersonalGoals = isNaN(percentagePersonalGoals)
              ? 0
              : percentagePersonalGoals;
            percentageQualitativeGoals = isNaN(percentageQualitativeGoals)
              ? 0
              : percentageQualitativeGoals;
            // points treatment
            acumulatedPointsQuantitative = isNaN(acumulatedPointsQuantitative)
              ? 0
              : acumulatedPointsQuantitative;
            acumulatedPointsPersonalGoals = isNaN(acumulatedPointsPersonalGoals)
              ? 0
              : acumulatedPointsPersonalGoals;
            acumulatedPointsQualitative = isNaN(acumulatedPointsQualitative)
              ? 0
              : acumulatedPointsQualitative;

            let totalPercentage =
              (Number(acumulatedPointsQuantitative) +
                Number(acumulatedPointsPersonalGoals) +
                Number(acumulatedPointsQualitative)) /
              1000;
            let totalPoints =
              Number(acumulatedPointsQuantitative) +
              Number(acumulatedPointsPersonalGoals) +
              Number(acumulatedPointsQualitative);

            if (this.resultGoalsAgd.length == 0) {
              this.resultGoalsAgd.push({
                item: "Métas Quanti e Quali",
                weight: "70%",
                percentage: percentageQuantitative,
                points: acumulatedPointsQuantitative,
              });
              this.resultGoalsAgd.push({
                item: "Apresentação Pessoal",
                weight: "10%",
                percentage: percentagePersonalGoals,
                points: acumulatedPointsPersonalGoals,
              });
              this.resultGoalsAgd.push({
                item: "Relacionamento crédito Cobrança",
                weight: "20%",
                percentage: percentageQualitativeGoals,
                points: acumulatedPointsQualitative,
              });
              this.resultGoalsAgd.push({
                item: "Total",
                weight: "100%",
                percentage: totalPercentage,
                points: totalPoints,
              });
            } else {
              //update results
              this.resultGoalsAgd.map((result) => {
                if (result.item == "Métas Quanti e Quali") {
                  result.percentage = percentageQuantitative;
                  result.points = acumulatedPointsQuantitative;
                } else if (result.item == "Apresentação Pessoal") {
                  result.percentage = percentagePersonalGoals;
                  result.points = acumulatedPointsPersonalGoals;
                } else if (result.item == "Relacionamento crédito Cobrança") {
                  result.percentage = acumulatedPointsQualitative;
                  result.points = percentageQualitativeGoals;
                } else if (result.item == "Total") {
                  result.percentage = totalPercentage;
                  result.points = totalPoints;
                }
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => console.log(error));
    },
    getParticipation() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
        .then((response) => {
          this.participations = response.data || [];
          this.participation = response.data[0] || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getRoles() {
      this.$http.secured.get("/api/v1/roles").then((response) => {
        this.roles = response.data.roles;
      });
    },
    async getUsers(query = "") {
      let data = { q: {name: query, role_id: this.filter.role.id}  };

       if (this.filter.role && this.filter.role.id) {
        data.q.role_id = this.filter.role.id;
      }
       if (this.filter.channel && this.filter.channel.id) {
        data.q.channel_id = this.filter.channel.id;
      }
      if (this.filter.type) {
        data.q.salesman_type = this.filter.type.code;
      }
      if (this.filter.manager && this.filter.manager.id) {
        data.q.manager_id = this.filter.manager.id;
      }

      this.loadingUsers = true

      try {
        const response = await this.$http.secured.get("/api/v1/users", { params: data })
        this.users = response.data.users;
      } catch (error) {
        console.warn("[PPR][Reports] getUsers", error)
      }

      this.loadingUsers = false
    },
    getTypes() {
      this.types = [
        {
          code: "campo",
          salesman_type: "CAMPO",
        },
        {
          code: "balcao",
          salesman_type: "BALCÃO",
        },
        {
          code: "redistribuicao",
          salesman_type: "REDISTRIBUIÇÃO",
        },
      ];
    },
    getChannels() {
      this.$http.secured
        .get(`/api/v1/channels`)
        .then((response) => {
          this.channels = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    findManagers(query) {
      var data = {
        per_page: 10,
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.managers = response.data.users;
        })
    },
    clearFilters() {
      this.filter.participation_ppr = {},
      this.filter.role = {},
      this.filter.manager = {},
      this.filter.type = {},
      this.filter.channel = {},
      this.filter.user = {}
    },
  },

  mounted() {
    this.getParticipation();
    this.getRoles();
    this.getUsers();
    this.getChannels();
    this.getTypes();
    // this.findSalesmans();
    this.findManagers();
  },

  watch: {
    "filter.role": function () {
      this.getUsers();
    },
    "filter.type": function () {
      this.getUsers();
    },
    "filter.channel": function () {
      this.getUsers();
    },
    'filter.user': function() {
      this.updateTypeAndChannel()
    },
    "filter.manager": function () {
      this.getUsers();
    },
  },
};
</script>

<style></style>
